import axios from 'axios';
import { API_INFO } from '../constants';
import useAssignedLibrary from 'utils/customHooks/useAssignedLibrary';
import { getApiLanguage } from 'utils/apiLanguage';
import { buildLocalizedPathname, isIntranetPath } from 'utils/localePath';

const headers = {
  'Content-Type': 'application/json'
};

const axiosInstance = axios.create({
  baseURL: API_INFO,
  headers: headers,
});


axiosInstance.interceptors.request.use(
  (config) => {
    config.headers['Accept-Language'] = getApiLanguage();

    const token = localStorage.getItem('access');
    if (token) {
      config.headers.Authorization = `JWT ${token}`;
      config.headers['Path-Frontend'] = window.location.pathname;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  },
);

axiosInstance.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;
    if (error.response.status === 401 && !originalRequest._retry) {
      originalRequest._retry = true;
      const refresh_token = localStorage.getItem('refresh');
      if (refresh_token) {
        const payload = { refresh: refresh_token };
        try {
          const { data } = await axios.post(API_INFO + 'token/refresh/', payload);
          localStorage.setItem('access', data.access);
          localStorage.setItem('refresh', data.refresh);
          axiosInstance.defaults.headers['Authorization'] = 'JWT ' + data.access;
          originalRequest.headers['Authorization'] = 'JWT ' + data.access;
          return axiosInstance(originalRequest);
        } catch (refreshError) {
          console.error(refreshError);
        }
      }
      localStorage.clear();
      const { assignedLibrary } = useAssignedLibrary();
      const loginPath = isIntranetPath(window.location.pathname)
        ? buildLocalizedPathname('/intranet/login', getApiLanguage())
        : `/${assignedLibrary}/inicio-sesion`;
      window.history.pushState({}, '', loginPath);
    }
    return Promise.reject(error);
  },
);

export default axiosInstance;
